import type {
  AuditLog,
  ImpersonationStartResponse,
  PaginatedResponse,
  Plan,
  SuperTenantDetail,
  SuperTenantListItem,
  TenantStatus,
} from "@chat-yai/shared";
import { request } from "@/api/client";

export const superApi = {
  listTenants(query: {
    status?: string;
    q?: string;
    page?: number;
    page_size?: number;
    sort?: string;
  }) {
    return request<PaginatedResponse<SuperTenantListItem>>("/super/tenants", {
      query,
    });
  },
  getTenant(id: string) {
    return request<SuperTenantDetail>(`/super/tenants/${id}`);
  },
  changePlan(id: string, input: { plan_code: string }) {
    return request<{ tenant: SuperTenantDetail["tenant"] }>(
      `/super/tenants/${id}/plan`,
      { method: "PATCH", body: input },
    );
  },
  changeStatus(id: string, input: { status: TenantStatus }) {
    return request<{ tenant: SuperTenantDetail["tenant"] }>(
      `/super/tenants/${id}/status`,
      { method: "PATCH", body: input },
    );
  },
  listPlans() {
    return request<{ plans: Plan[] }>("/super/plans");
  },
  startImpersonation(input: {
    target_user_id: string;
    target_tenant_id: string;
    reason: string;
    ticket_ref?: string;
  }) {
    return request<ImpersonationStartResponse>("/super/impersonations", {
      method: "POST",
      body: input,
    });
  },
  endImpersonation(id: string) {
    return request<{ ok: true }>(`/super/impersonations/${id}/end`, {
      method: "POST",
    });
  },
  auditLogs(query: {
    tenant_id?: string;
    action?: string;
    from?: string;
    to?: string;
    page?: number;
    page_size?: number;
  }) {
    return request<PaginatedResponse<AuditLog>>("/super/audit-logs", { query });
  },
};
